<template>
    <div>
      <div v-if="airline">
        <h1>Airline: {{ airline.name }}</h1>
        <div class="box">
          <Errors/>
          <form class="form" v-on:submit.prevent="updateAirline">
            <AirlineFields/>
            <div class="form-wrap form-submit">
              <div v-if="this.getLoadStatus">
                <button type="submit" class="button" disabled><span>Updating...</span></button>
              </div>
              <div v-else>
                <button type="submit" class="button" v-if="userRole == 1"><span>Update Airline</span></button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>

    <script>
    import AirlineFields from '@/components/AirlineFields.vue'
    import Errors from '@/components/Errors.vue'
    import {mapGetters} from 'vuex'
    export default {
      name: 'AirlineEdit',
      computed: {
        ...mapGetters(['getLoadStatus']),
        userRole() {
          return localStorage.getItem("user_role");
        }
      },
      data () {
        return {
          airline: null,
          errors: null
        }
      },
      components: {
        AirlineFields,
        Errors
      },
      created () {
        this.getAirline()
      },
      watch: {
        '$route': 'getAirline'
      },
      methods: {
        getAirline () {
          this.$store.dispatch('setLoadStatus')
          fetch(this.$api + 'airlines/' + this.$route.params.id, {
            headers: {
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          })
          .then(res => res.json())
          .then(response => {
            this.$store.dispatch('setLoadStatus')
            this.airline = response.data
          })
        },
        updateAirline () {
          this.$store.dispatch('setLoadStatus');
          let formData = new FormData();

          formData.append('name', this.airline.name);
          formData.append('contact_name', this.airline.contact_name);
          formData.append('web_check_in_before_days', this.airline.web_check_in_before_days);
          formData.append('airline_content', this.airline.airline_content);
          formData.append('instruction_doc_file', this.airline.instruction_doc);
          formData.append('checkin_video_desktop_url', this.airline.checkin_video_desktop_url || '');
          formData.append('checkin_video_mobile_url', this.airline.checkin_video_mobile_url || '');
          formData.append('airline_code', this.airline.airline_code);
          formData.append('flight_times_code', this.airline.flight_times_code);
          formData.append('flight_budget_code', this.airline.flight_budget_code);
          formData.append('web_url', this.airline.web_url);
          fetch(this.$api + 'airlines/' + this.$route.params.id, {
            method: 'POST',
            body: formData,
            headers: {
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          })
          .then(res => res.json())
          .then(response => {
            if(response.success) {
              this.$notify({
                type: 'success',
                title: response.message
              });
              document.getElementById("file-upload").value = "";
              this.getAirline();
            } else if (response.errors) {
              this.$notify({
                type: 'error',
                title: response.message
              });
            }
            this.$store.dispatch('setLoadStatus')
          });
        }
      }
    }
    </script>
